import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

// TODO better types
const addBorderInHighContrastMode: any = addHighContrastStyles(({ theme }) => ({
  border: `2px solid ${theme.palette.divider}`,
}));

export default addBorderInHighContrastMode;
